import { Component, OnInit, ViewChild,HostListener } from '@angular/core';
import { HelperService } from '../helper.service';
import { Subject } from 'rxjs/Subject';
import { Http, Response,Headers } from '@angular/http';
import 'rxjs/add/operator/map';
import { DataTableDirective } from 'angular-datatables';
import {MatSnackBar} from '@angular/material';
import { NgForm } from '@angular/forms';
import { Router,ActivatedRoute, Params } from '@angular/router';
import {FormControl} from '@angular/forms';
import {MatDatepickerInputEvent} from '@angular/material/datepicker';
import {MatAutocompleteModule} from '@angular/material/autocomplete';
import {CookieService} from 'angular2-cookie/core';

@Component({
  selector: 'app-sale-details',
  templateUrl: './sale-details.component.html',
  styleUrls: ['./sale-details.component.css']
})
export class SaleDetailsComponent implements OnInit {

  // 	@HostListener('window:beforeunload', ['$event'])
//   unloadHandler(event: Event) {
//   localStorage.removeItem('access_token');
//   localStorage.removeItem('navigateroute');
// }
order=0;
note;
payment_status=0;
salesDetails=[];
invoice_url;
user_permissions:any=[];
user=this.cookie.get('user_id');
user_token= localStorage.getItem('access_token');
  private headers: Headers = new Headers({
  'Accept': 'application/json',
  'Authorization': "Bearer "+this.user_token
});
  constructor(private helper:HelperService,private http:Http,private snackbar: MatSnackBar,private activatedRouter:ActivatedRoute,private router:Router,private cookie:CookieService) {
    this.activatedRouter.params.subscribe((params: Params) => {
    console.log(params);
      this.order = params['id'];
      
    });

    
  }

  ngOnInit() {

    this.http.get(this.helper.base_url+'http/salesReportDetails/'+this.order,{ headers: this.headers })
      
      .subscribe(data => {
        this.salesDetails = JSON.parse(data['_body']);
        this.payment_status = JSON.parse(data['_body']).status;
        this.invoice_url = this.helper.base_url+'http/printOrder/'+this.order;
      });
      this.http.get(this.helper.base_url+'/http/get/user/permissions',{ headers: this.headers })
    
    .subscribe(data => {
      this.user_permissions = JSON.parse(data['_body']);
     //console.log(this.user_permissions);
        
     
    });
  }

  refresh(val=false,msg='')
  {
   
    this.snackbar.open(msg, null, {
      duration:5000,
        extraClasses:'success-snackbar',
        verticalPosition:'top'
      });
    this.router.navigateByUrl('/redirect', {skipLocationChange: true}).then(()=>
    this.router.navigate(["order/"+this.order]));
      
 }

  changeStatus(statusForm: NgForm)
  {
    if(confirm("Are you sure to change the status")) 
    {
      let body = new FormData();
      body.append('status', statusForm.value.status);
      body.append('note', statusForm.value.note);
      //body.append('user', this.user);
     
      this.http.post(this.helper.base_url+'http/changeOrderStatus/'+this.order, body,{ headers: this.headers })
      .subscribe(
        (res) => {
          let body = JSON.parse(res['_body']);
          if(body.success == 1)
          {
            this.refresh(false,body.message) ;
          }
          else
          {
            this.snackbar.open(body.message, null, {
              duration:5000,
                extraClasses:'error-snackbar',
                verticalPosition:'bottom'
              });
          }
        }, //For Success Response
         err => {console.error(err)} //For Error Response);
      );
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/sale-details/sale-details.component.ts